<template>
  <div class="select-employees">
    <div class="select-employees__find-box">
      <v-text-field
        class="input-search dark"
        v-model.trim="searchText"
        single-line
        :placeholder="$t('select_employees.find_employee')"
      >
        <template v-slot:prepend-inner>
          <SvgIcon width="20" height="20" icon="Search" />
        </template>
      </v-text-field>
    </div>
    <div class="select-employees__list" :class="{ 'select-employees__list__empty': emptyTags }">
      <div
        class="select-employees__list-item"
        v-for="item in filteredItems"
        :key="item._id"
        @click="handleSelectTag(item._id)"
      >
        <div class="select-employees__list-item__content">
          <div>{{ item.name }}</div>
          <div>{{ item.phone }}</div>
        </div>
        <SvgIcon v-if="selectedId.includes(item._id)" height="16" width="16" icon="Check" />
      </div>

      <div v-if="emptyTags">
        {{ $t('select_employees.not_found') }}
      </div>
    </div>
    <div class="select-employees__actions">
      <v-btn @click="handleClose" flat>{{ $t('close') }}</v-btn>
      <v-btn @click="handleSubmitSelect" depressed color="accent">{{ $t('apply') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { removeUnicode } from '@/plugins/util'

export default {
  name: 'SelectTag',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    id: {
      type: Array,
      default: () => []
    },
    onChange: {
      type: Function
    },
    onClose: {
      type: Function
    }
  },
  data() {
    return {
      selectedId: (this.id && [...this.id]) || [],
      filteredItems: [],
      searchText: ''
    }
  },
  computed: {
    emptyTags() {
      return this.items.length === 0 || (this.searchText && this.filteredItems.length === 0)
    }
  },
  methods: {
    handleSelectTag(id) {
      if (this.selectedId.includes(id)) {
        const index = this.selectedId.findIndex((i) => i === id)
        this.selectedId.splice(index, 1)
      } else {
        this.selectedId.push(id)
      }
    },
    getFilteredTag() {
      let filteredItems = []
      let _searchText = ''

      if (this.searchText) {
        _searchText = removeUnicode(this.searchText)
      }

      this.items.forEach((item) => {
        let matched = true
        if (_searchText) {
          const itemName = (item.name && removeUnicode(item.name)) || ''
          const itemPhone = item._id || ''

          if (!itemName.includes(_searchText) && !itemPhone.includes(_searchText)) matched = false
        }

        if (matched) {
          filteredItems.push(item)
        }
      })

      this.filteredItems = filteredItems
    },
    handleSubmitSelect() {
      this.$emit('onChange', this.selectedId)
    },
    handleClose() {
      this.$emit('onClose')
    }
  },
  mounted() {
    this.getFilteredTag()
  },
  watch: {
    searchText() {
      this.getFilteredTag()
    }
  }
}
</script>

<style lang="scss" scoped>
.select-employees {
  max-height: inherit;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  background-color: #fff;
  padding-top: 16px;

  .select-employees__find-box {
    margin-bottom: 12px;
    padding: 0 16px;
  }

  .select-employees__list {
    overflow-y: auto;
    min-height: 110px;

    &.select-employees__list__empty {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #7a8189;
    }

    .select-employees__list-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-height: 36px;
      padding: 4px 16px;
      cursor: pointer;

      &:hover {
        background-color: #f8f8f8;
      }

      .select-employees__list-item__content {
        > div:first-child {
          color: #1a1a1a;
        }

        > div:last-child {
          color: #7a8190;
          font-size: 13px;
        }
      }
    }
  }

  .select-employees__create-tag {
    border-top: 1px solid #f2f2f2;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    &:hover {
      background-color: #f2f2f2;
    }
  }

  .select-employees__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 16px;
    box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.15);

    button {
      text-transform: none;
      height: 40px;
      margin: 0;

      &:first-child {
        margin-right: 8px;
      }
    }
  }
}
</style>

<style lang="scss">
.select-employees {
  .select-employees__find-box {
    .input-search {
      // Disable style of vuetify
      &.v-input {
        padding: 0;
        margin: 0;
      }
      // End disable style of vuetify

      .v-input__slot {
        // Disable style of vuetify
        // remove border
        border: none !important;

        // remove border on hover
        &:hover,
        &:focus-within {
          border: none !important;
        }

        // remove border on focus
        &::before,
        &::after {
          display: none;
        }
        // Update custom style
        height: 36px;
        background-color: #fff;
        display: flex;
        padding: 0 12px;
        border-radius: 66px;
        margin-bottom: 0;

        .v-label {
          font-size: 14px !important;

          &.v-label--active {
            font-size: 14px !important;
          }
        }

        // Style for input
        .v-text-field__slot {
          input {
            padding: 6px 0;
            font-size: 14px;

            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
              display: none;
              -webkit-appearance: none;
              margin: 0;
            }

            &[type='number'] {
              -moz-appearance: textfield; /* Firefox */
            }
          }
        }

        .v-input__append-inner,
        .v-input__prepend-inner {
          margin: 0;
          height: 100%;
          display: flex;
          align-items: center;
        }

        .v-input__prepend-inner {
          padding-right: 10px;
        }
        //End update custom style
      }

      // Update custom style
      // Set color for icon if warning state
      .warning-icon {
        svg {
          path {
            fill: #ffab00;
          }
        }
      }

      &.dark {
        .v-input__slot {
          background-color: #f2f2f2;
        }
      }

      .v-text-field__details {
        padding-left: 12px;
      }

      &.v-input--is-focused {
        .v-label {
          color: #ff8200 !important;

          &.error--text {
            color: #d44632 !important;
            caret-color: #d44632 !important;
          }
        }

        .v-input__prepend-inner {
          svg {
            path {
              fill: #1a1a1a;
            }
          }
        }
      }

      &.error--text {
        color: #d44632 !important;
        caret-color: #d44632 !important;
      }
      //End update custom style
    }
  }

  .select-employees__list-item,
  .select-employees__create-tag {
    svg {
      path {
        fill: #ff8200;
      }
    }
  }
}
</style>
